import React, { useState, useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TopBar from "../TopBar";

// Import the sub-components we created below
import StyledHeader from "./StyledHeader";
import CategoryCarousel from "./CategoryCarousel";
import CoolDrawer from "./CoolDrawer";
import TravelPopup from "./TravelPopup";

const NavbarMobile = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // POPUP TIMER
  useEffect(() => {
    const timer = setTimeout(() => {
      setPopupOpen(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false); // Close drawer if open
  };

  const toggleDrawer = (open) => (event) => {

    setDrawerOpen(open);
  
  };

  return (
    <>
      <TopBar />

      {/* STICKY WRAPPER */}
      <Box sx={{ position: 'sticky', top: 0, zIndex: 1100 }}>
        
        {/* 1. THE HEADER (Logo + Menu) */}
        <StyledHeader 
          onMenuClick={toggleDrawer(true)} 
          onLogoClick={() => navigate("/")} 
        />  

        {/* 2. THE COOL CATEGORY ROW (Images + No Scroll / Fit Width) */}
        <CategoryCarousel onNavigate={handleNavigation} />
      </Box>

      {/* 3. THE SIDE DRAWER (Full Menu) */}
      <CoolDrawer 
        open={drawerOpen} 
        onClose={toggleDrawer(false)} 
        onNavigate={handleNavigation} 
      />

      {/* 4. THE NOTIFICATION POPUP */}
      <TravelPopup 
        open={popupOpen} 
        onClose={() => setPopupOpen(false)} 
      />
    </>
  );
};

export default NavbarMobile;